import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

// Service worker: register in production only. In development the cache-first SW
// fights the dev server's live-reload (stale content -> endless reloading), so we
// actively unregister any existing SW and clear its caches to self-heal the browser.
if ('serviceWorker' in navigator) {
    if (process.env.NODE_ENV === 'production') {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js').catch(() => {
                // Registration failed - non-critical, PWA features will be unavailable
            });
        });
    } else {
        navigator.serviceWorker.getRegistrations().then((regs) => {
            regs.forEach((reg) => reg.unregister());
        });
        if (window.caches) {
            caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
        }
    }
}

const rootElement = document.getElementById('root') as HTMLElement;

// Static SEO pages (e.g. Shiva Purana chapters) carry simple crawler-readable markup
// that is NOT the React tree, so it must be replaced, not hydrated.
if (rootElement.hasChildNodes() && !rootElement.hasAttribute('data-static-seo')) {
    // Pre-rendered HTML exists — hydrate to attach event handlers
    ReactDOM.hydrateRoot(
        rootElement,
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    // No pre-rendered HTML — normal client-side render
    ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}